import React from 'react';
import { UserContext } from "../contexts/UserContext";
import { userService } from "../services/UserService";
import UserContextProvider from "../contexts/UserContext";

import { useParams } from 'react-router-dom';

const SubscriptionPageForm = () => {

    let { subscription } = useParams();

    const { userState, dispatch } = React.useContext(UserContext);

    // Validate and use the subscription ID
    const validateAndUseSubscription = (subscription) => {
        const validIds = [1, 2, 3, 4, 5];
        const id = parseInt(subscription, 10);

        if (validIds.includes(id)) {
            const body = { id, quantity: 1 };
            userService.pay(dispatch, body).catch(error => {
                // handle the error
                console.error("Payment failed:", error);
            });
        } else {
            console.warn("Invalid subscription ID");
            // Handle invalid subscription ID as needed
        }
    }

    // Use effect to trigger the validation and payment process
    React.useEffect(() => {
        if (dispatch) {
            validateAndUseSubscription(subscription);
        }
    }, [dispatch, subscription]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-200">
            <div className="flex flex-col items-center space-y-8 p-10">
                {/* Your UI components */}
            </div>
        </div>
    );
}

export default SubscriptionPageForm;